import { create } from "zustand";
import {
  EXPERIMENT_MOBILE_FULLSCREEN,
  MOBILE_FULLSCREEN_VARIANT_A,
  MOBILE_FULLSCREEN_VARIANT_B,
  MOBILE_FULLSCREEN_VARIANT_C,
  TMobileFullscreenVariant,
} from "@/common/services/experiment/constants";
import assignmentService from "@/common/services/experiment/assignmentService";

interface IMobileFullscreenExperimentState {
  variant: TMobileFullscreenVariant;
}

export const useMobileFullscreenExperimentStore = create<IMobileFullscreenExperimentState>(() => ({
  variant: MOBILE_FULLSCREEN_VARIANT_A,
}));

const sanitizeVariant = (assignment: string | boolean): TMobileFullscreenVariant => {
  if (assignment === MOBILE_FULLSCREEN_VARIANT_B || assignment === MOBILE_FULLSCREEN_VARIANT_C) {
    return assignment;
  }

  return MOBILE_FULLSCREEN_VARIANT_A;
};

/* Request dedupe and exposure dedupe both live in assignmentService, so calling
   this per mount is cheap: cached reads plus a same-value store write. */
export const resolveMobileFullscreenVariant = async (): Promise<TMobileFullscreenVariant> => {
  const assignment = await assignmentService.get(
    EXPERIMENT_MOBILE_FULLSCREEN,
    MOBILE_FULLSCREEN_VARIANT_A
  );
  const variant = sanitizeVariant(assignment);

  useMobileFullscreenExperimentStore.setState({ variant });

  return variant;
};
